<div [class.mobile-overlay-ui]="isMobile()">
  <!--TO DO: Create storybook component for avatar video-->
  <div class="avatar-caption-overlay">
    <div class="avatar-video-circle" aria-label="Avatar video">
      @if (!avatarVideoPlaying()) {
        <div class="avatar-loader" aria-label="Loading avatar">
          <qai-call-audio-indicator size="small" status="loading" />
        </div>
      }
      <video
        id="avatar-video-realtime"
        [attr.playsinline]="true"
        [attr.webkit-playsinline]="true"
        class="avatar-video-realtime"
        (playing)="handleAvatarVideoPlaying()"
        (error)="handleAvatarVideoError()"
      ></video>
    </div>
    <audio
      id="avatar-audio-realtime"
      [attr.playsinline]="true"
      [attr.webkit-playsinline]="true"
    ></audio>
  </div>
  @if (captionsOn() && (captionText()?.trim()?.length ?? 0) > 0) {
    <div class="captions-wrapper">
      <qai-call-captions [maxLines]="4" [style.width.px]="!isMobile() ? cardWidthPx() : null">
        {{ captionText() }}
      </qai-call-captions>
    </div>
  }
</div>
<div class="preamble">

  @if (isMobile()) {
    <div class="mobile-stack">
      @for (tab of parsedTabs(); track tab.tabSequence) {
        <div class="tab-card">
          <h3 class="tab-title">{{ tab.tabTitle }}</h3>
          <div class="tab-content">
            @for (block of tab.blocks; track $index) {
              @switch (block.type) {
                @case ('heading') {
                  <strong class="tab-heading">{{ block.text }}</strong>
                }
                @case ('subheading') {
                  <h5 class="subheading">{{ block.text }}</h5>
                }
                @case ('body') {
                  <p class="body-text">{{ block.text }}</p>
                }
                @case ('check-item') {
                  <div class="check-item">
                    <div class="check-icon-wrapper">
                      <qai-icon kind="check" color="#3796A4" size="14px"/>
                    </div>
                    <span class="check-text">{{ block.text }}</span>
                  </div>
                }
                @case ('bullet') {
                  <div class="bullet-item">
                    <span class="bullet-dot" aria-hidden="true">•</span>
                    <span>{{ block.text }}</span>
                  </div>
                }
              }
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <qai-carousel (cardWidthChange)="cardWidthPx.set($event)">

      @for (tab of parsedTabs(); track tab.tabSequence) {
        <div qaiCarouselItem class="tab-card">
          <h3 class="tab-title">{{ tab.tabTitle }}</h3>
          <div class="tab-content">
            @for (block of tab.blocks; track $index) {
              @switch (block.type) {
                @case ('heading') {
                  <strong class="tab-heading">{{ block.text }}</strong>
                }
                @case ('subheading') {
                  <h5 class="subheading">{{ block.text }}</h5>
                }
                @case ('body') {
                  <p class="body-text">{{ block.text }}</p>
                }
                @case ('check-item') {
                  <div class="check-item">
                    <div class="check-icon-wrapper">
                      <qai-icon kind="check" color="#3796A4" size="14px"/>
                    </div>
                    <span class="check-text">{{ block.text }}</span>
                  </div>
                }
                @case ('bullet') {
                  <div class="bullet-item">
                    <span class="bullet-dot" aria-hidden="true">•</span>
                    <span>{{ block.text }}</span>
                  </div>
                }
              }
            }
          </div>
        </div>
      }
    </qai-carousel>
  }
</div>